// src/routes/index.js에 다음과 같이 AI 모델링 페이지 추가
import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import {
  MainingPage,
  Company,
  Business,
  Organization,
  NoticeingPage,
  ScrollToTop,
} from "../screen";
import {
  NavigationBarPage,
  FooterContainer,
} from "../containers";
import ExchangeEnginePage from "../pages/ExchangeEngine"; 
import DeepLearningPage from "../pages/DeepLearning"; 
import AIModelingPage from "../pages/AIModeling"; // AI 모델링 페이지 import 추가
import ISMSCertificationPage from "../pages/ISMSCertification"; // ISMS 인증 페이지 추가


import styled from "styled-components";
class GravisionRoute extends Component {
  render() {
    return (
      <Router>
        <Nav>
          <NavigationBarPage />
        </Nav>
        <ScrollToTop>
          <Switch>
            <Route exact path="/" component={MainingPage} />
            <Route path="/company" component={Company} />
            <Route path="/business" component={Business} />
            <Route path="/organization" component={Organization} />
            <Route path="/notice" component={NoticeingPage} />
            <Route path="/services/exchange" component={ExchangeEnginePage} />
            <Route path="/services/deeplearning" component={DeepLearningPage} />
            <Route path="/services/aimodeling" component={AIModelingPage} /> {/* AI 모델링 페이지 라우트 추가 */}
            <Route path="/services/isms" component={ISMSCertificationPage} /> {/* ISMS 인증 페이지 라우트 추가 */}
          </Switch>
        </ScrollToTop>
        <FooterContainer />
      </Router>
    );
  }
}

const Nav = styled.div`
  position: absolute;
  width: 100%;
  z-index: 999;
`;
export { GravisionRoute };